import { getWmoInfo } from '../utils/wmoWeather';

export interface City {
  name: string;    // zh-TW（用作 toggle 識別 key）
  nameEn: string;  // English
  lat: number;
  lng: number;
}

export interface CityWeather extends City {
  temp: number;
  apparentTemp: number;
  tempMax: number;
  tempMin: number;
  humidity: number;
  windSpeed: number;
  weatherCode: number;
  emoji: string;
  // label 移除 — 在 render 時呼叫 getWmoInfo(weatherCode, lang) 取得，避免快取語系不符
}

export const CITIES: City[] = [
  // ── 台灣 ──────────────────────────────────────────────────────────────────
  { name: '台北',      nameEn: 'Taipei',               lat:  25.04, lng: 121.53 },
  { name: '台中',      nameEn: 'Taichung',              lat:  24.15, lng: 120.68 },
  { name: '台南',      nameEn: 'Tainan',                lat:  22.99, lng: 120.20 },
  { name: '高雄',      nameEn: 'Kaohsiung',             lat:  22.63, lng: 120.30 },
  { name: '花蓮',      nameEn: 'Hualien',               lat:  23.97, lng: 121.60 },
  // ── 東北亞 ────────────────────────────────────────────────────────────────
  { name: '東京',      nameEn: 'Tokyo',                 lat:  35.68, lng: 139.69 },
  { name: '首爾',      nameEn: 'Seoul',                 lat:  37.57, lng: 126.98 },
  { name: '北京',      nameEn: 'Beijing',               lat:  39.91, lng: 116.39 },
  { name: '上海',      nameEn: 'Shanghai',              lat:  31.23, lng: 121.47 },
  { name: '平壤',      nameEn: 'Pyongyang',             lat:  39.02, lng: 125.74 },
  { name: '烏蘭巴托',  nameEn: 'Ulaanbaatar',           lat:  47.91, lng: 106.88 },
  // ── 東南亞 ────────────────────────────────────────────────────────────────
  { name: '新加坡',    nameEn: 'Singapore',             lat:   1.35, lng: 103.82 },
  { name: '曼谷',      nameEn: 'Bangkok',               lat:  13.75, lng: 100.52 },
  { name: '河內',      nameEn: 'Hanoi',                 lat:  21.03, lng: 105.85 },
  { name: '雅加達',    nameEn: 'Jakarta',               lat:  -6.21, lng: 106.85 },
  { name: '吉隆坡',    nameEn: 'Kuala Lumpur',          lat:   3.15, lng: 101.71 },
  { name: '馬尼拉',    nameEn: 'Manila',                lat:  14.60, lng: 120.98 },
  { name: '金邊',      nameEn: 'Phnom Penh',            lat:  11.56, lng: 104.92 },
  { name: '萬象',      nameEn: 'Vientiane',             lat:  17.97, lng: 102.60 },
  { name: '奈比多',    nameEn: 'Naypyidaw',             lat:  19.75, lng:  96.13 },
  { name: '斯里巴加灣', nameEn: 'Bandar Seri Begawan',  lat:   4.94, lng: 114.95 },
  { name: '帝力',      nameEn: 'Dili',                  lat:  -8.56, lng: 125.59 },
  // ── 南亞 ──────────────────────────────────────────────────────────────────
  { name: '新德里',    nameEn: 'New Delhi',             lat:  28.61, lng:  77.21 },
  { name: '伊斯蘭瑪巴德', nameEn: 'Islamabad',          lat:  33.72, lng:  73.06 },
  { name: '達卡',      nameEn: 'Dhaka',                 lat:  23.72, lng:  90.41 },
  { name: '可倫坡',    nameEn: 'Colombo',               lat:   6.93, lng:  79.86 },
  { name: '加德滿都',  nameEn: 'Kathmandu',             lat:  27.70, lng:  85.32 },
  { name: '廷布',      nameEn: 'Thimphu',               lat:  27.47, lng:  89.64 },
  { name: '馬列',      nameEn: 'Malé',                  lat:   4.18, lng:  73.51 },
  { name: '喀布爾',    nameEn: 'Kabul',                 lat:  34.53, lng:  69.17 },
  // ── 中亞 ──────────────────────────────────────────────────────────────────
  { name: '阿斯塔納',  nameEn: 'Astana',                lat:  51.18, lng:  71.45 },
  { name: '塔什干',    nameEn: 'Tashkent',              lat:  41.30, lng:  69.27 },
  { name: '比什凱克',  nameEn: 'Bishkek',               lat:  42.87, lng:  74.59 },
  { name: '杜尚別',    nameEn: 'Dushanbe',              lat:  38.56, lng:  68.77 },
  { name: '阿什哈巴德', nameEn: 'Ashgabat',             lat:  37.95, lng:  58.38 },
  // ── 西亞／中東 ────────────────────────────────────────────────────────────
  { name: '安卡拉',    nameEn: 'Ankara',                lat:  39.93, lng:  32.85 },
  { name: '德黑蘭',    nameEn: 'Tehran',                lat:  35.69, lng:  51.39 },
  { name: '巴格達',    nameEn: 'Baghdad',               lat:  33.34, lng:  44.40 },
  { name: '大馬士革',  nameEn: 'Damascus',              lat:  33.51, lng:  36.29 },
  { name: '貝魯特',    nameEn: 'Beirut',                lat:  33.89, lng:  35.50 },
  { name: '安曼',      nameEn: 'Amman',                 lat:  31.95, lng:  35.93 },
  { name: '耶路撒冷',  nameEn: 'Jerusalem',             lat:  31.78, lng:  35.22 },
  { name: '利雅德',    nameEn: 'Riyadh',                lat:  24.69, lng:  46.72 },
  { name: '科威特城',  nameEn: 'Kuwait City',           lat:  29.37, lng:  47.98 },
  { name: '麥納瑪',    nameEn: 'Manama',                lat:  26.21, lng:  50.59 },
  { name: '杜哈',      nameEn: 'Doha',                  lat:  25.29, lng:  51.53 },
  { name: '杜拜',      nameEn: 'Dubai',                 lat:  25.20, lng:  55.27 },
  { name: '阿布達比',  nameEn: 'Abu Dhabi',             lat:  24.47, lng:  54.37 },
  { name: '馬斯喀特',  nameEn: 'Muscat',                lat:  23.61, lng:  58.59 },
  { name: '沙那',      nameEn: "Sana'a",                lat:  15.35, lng:  44.21 },
  { name: '尼科西亞',  nameEn: 'Nicosia',               lat:  35.17, lng:  33.37 },
  // ── 高加索 ────────────────────────────────────────────────────────────────
  { name: '耶烈萬',    nameEn: 'Yerevan',               lat:  40.18, lng:  44.51 },
  { name: '巴庫',      nameEn: 'Baku',                  lat:  40.41, lng:  49.87 },
  { name: '提比里斯',  nameEn: 'Tbilisi',               lat:  41.69, lng:  44.83 },
  // ── 歐洲 ──────────────────────────────────────────────────────────────────
  { name: '莫斯科',    nameEn: 'Moscow',                lat:  55.75, lng:  37.62 },
  { name: '基輔',      nameEn: 'Kyiv',                  lat:  50.45, lng:  30.52 },
  { name: '明斯克',    nameEn: 'Minsk',                 lat:  53.90, lng:  27.57 },
  { name: '倫敦',      nameEn: 'London',                lat:  51.51, lng:  -0.13 },
  { name: '巴黎',      nameEn: 'Paris',                 lat:  48.86, lng:   2.35 },
  { name: '柏林',      nameEn: 'Berlin',                lat:  52.52, lng:  13.41 },
  { name: '羅馬',      nameEn: 'Rome',                  lat:  41.90, lng:  12.50 },
  { name: '馬德里',    nameEn: 'Madrid',                lat:  40.42, lng:  -3.70 },
  { name: '阿姆斯特丹', nameEn: 'Amsterdam',            lat:  52.37, lng:   4.90 },
  { name: '布魯塞爾',  nameEn: 'Brussels',              lat:  50.85, lng:   4.35 },
  { name: '維也納',    nameEn: 'Vienna',                lat:  48.21, lng:  16.37 },
  { name: '布拉格',    nameEn: 'Prague',                lat:  50.08, lng:  14.44 },
  { name: '華沙',      nameEn: 'Warsaw',                lat:  52.23, lng:  21.01 },
  { name: '布達佩斯',  nameEn: 'Budapest',              lat:  47.50, lng:  19.04 },
  { name: '布加勒斯特', nameEn: 'Bucharest',            lat:  44.43, lng:  26.10 },
  { name: '雅典',      nameEn: 'Athens',                lat:  37.98, lng:  23.73 },
  { name: '索菲亞',    nameEn: 'Sofia',                 lat:  42.70, lng:  23.32 },
  { name: '貝爾格勒',  nameEn: 'Belgrade',              lat:  44.80, lng:  20.47 },
  { name: '薩格勒布',  nameEn: 'Zagreb',                lat:  45.81, lng:  15.98 },
  { name: '薩拉熱窩',  nameEn: 'Sarajevo',              lat:  43.85, lng:  18.36 },
  { name: '盧布爾雅那', nameEn: 'Ljubljana',            lat:  46.05, lng:  14.51 },
  { name: '斯科普里',  nameEn: 'Skopje',                lat:  41.99, lng:  21.43 },
  { name: '地拉那',    nameEn: 'Tirana',                lat:  41.33, lng:  19.82 },
  { name: '波德戈里察', nameEn: 'Podgorica',            lat:  42.44, lng:  19.26 },
  { name: '普里斯提納', nameEn: 'Pristina',             lat:  42.67, lng:  21.17 },
  { name: '基希訥烏',  nameEn: 'Chișinău',              lat:  47.00, lng:  28.86 },
  { name: '里加',      nameEn: 'Riga',                  lat:  56.95, lng:  24.11 },
  { name: '維爾紐斯',  nameEn: 'Vilnius',               lat:  54.69, lng:  25.28 },
  { name: '塔林',      nameEn: 'Tallinn',               lat:  59.44, lng:  24.75 },
  { name: '赫爾辛基',  nameEn: 'Helsinki',              lat:  60.17, lng:  24.94 },
  { name: '斯德哥爾摩', nameEn: 'Stockholm',            lat:  59.33, lng:  18.07 },
  { name: '奧斯陸',    nameEn: 'Oslo',                  lat:  59.91, lng:  10.75 },
  { name: '哥本哈根',  nameEn: 'Copenhagen',            lat:  55.68, lng:  12.57 },
  { name: '雷克雅維克', nameEn: 'Reykjavik',            lat:  64.14, lng: -21.90 },
  { name: '里斯本',    nameEn: 'Lisbon',                lat:  38.72, lng:  -9.14 },
  { name: '都柏林',    nameEn: 'Dublin',                lat:  53.33, lng:  -6.25 },
  { name: '伯恩',      nameEn: 'Bern',                  lat:  46.95, lng:   7.45 },
  { name: '盧森堡市',  nameEn: 'Luxembourg City',       lat:  49.61, lng:   6.13 },
  { name: '瓦萊塔',    nameEn: 'Valletta',              lat:  35.90, lng:  14.51 },
  { name: '布拉提斯拉瓦', nameEn: 'Bratislava',         lat:  48.15, lng:  17.12 },
  { name: '安道爾城',  nameEn: 'Andorra la Vella',      lat:  42.51, lng:   1.52 },
  { name: '摩納哥',    nameEn: 'Monaco',                lat:  43.73, lng:   7.42 },
  { name: '梵蒂岡',    nameEn: 'Vatican City',          lat:  41.90, lng:  12.45 },
  { name: '聖馬利諾城', nameEn: 'San Marino',           lat:  43.94, lng:  12.46 },
  { name: '瓦都茲',    nameEn: 'Vaduz',                 lat:  47.14, lng:   9.52 },
  // ── 非洲：北非 ───────────────────────────────────────────────────────────
  { name: '開羅',      nameEn: 'Cairo',                 lat:  30.04, lng:  31.24 },
  { name: '拉巴特',    nameEn: 'Rabat',                 lat:  34.01, lng:  -6.85 },
  { name: '的黎波里',  nameEn: 'Tripoli',               lat:  32.90, lng:  13.18 },
  { name: '突尼斯',    nameEn: 'Tunis',                 lat:  36.82, lng:  10.17 },
  { name: '阿爾及爾',  nameEn: 'Algiers',               lat:  36.74, lng:   3.06 },
  { name: '喀土穆',    nameEn: 'Khartoum',              lat:  15.55, lng:  32.53 },
  // ── 非洲：西非 ───────────────────────────────────────────────────────────
  { name: '努瓦克肖特', nameEn: 'Nouakchott',           lat:  18.08, lng: -15.97 },
  { name: '達喀爾',    nameEn: 'Dakar',                 lat:  14.69, lng: -17.44 },
  { name: '班竹爾',    nameEn: 'Banjul',                lat:  13.45, lng: -16.58 },
  { name: '比紹',      nameEn: 'Bissau',                lat:  11.86, lng: -15.60 },
  { name: '科納克里',  nameEn: 'Conakry',               lat:   9.54, lng: -13.68 },
  { name: '自由城',    nameEn: 'Freetown',              lat:   8.49, lng: -13.23 },
  { name: '蒙羅維亞',  nameEn: 'Monrovia',              lat:   6.30, lng: -10.80 },
  { name: '阿克拉',    nameEn: 'Accra',                 lat:   5.56, lng:  -0.20 },
  { name: '亞穆蘇克羅', nameEn: 'Yamoussoukro',         lat:   6.82, lng:  -5.28 },
  { name: '洛美',      nameEn: 'Lomé',                  lat:   6.14, lng:   1.22 },
  { name: '波多諾伏',  nameEn: 'Porto-Novo',            lat:   6.37, lng:   2.42 },
  { name: '阿布賈',    nameEn: 'Abuja',                 lat:   9.07, lng:   7.40 },
  { name: '尼亞美',    nameEn: 'Niamey',                lat:  13.51, lng:   2.12 },
  { name: '瓦加杜古',  nameEn: 'Ouagadougou',           lat:  12.36, lng:  -1.53 },
  { name: '巴馬科',    nameEn: 'Bamako',                lat:  12.65, lng:  -8.00 },
  { name: '培亞',      nameEn: 'Praia',                 lat:  14.93, lng: -23.51 },
  // ── 非洲：中非 ───────────────────────────────────────────────────────────
  { name: '恩賈梅納',  nameEn: "N'Djamena",             lat:  12.11, lng:  15.04 },
  { name: '馬拉博',    nameEn: 'Malabo',                lat:   3.75, lng:   8.78 },
  { name: '雅溫德',    nameEn: 'Yaoundé',               lat:   3.87, lng:  11.52 },
  { name: '班吉',      nameEn: 'Bangui',                lat:   4.36, lng:  18.56 },
  { name: '布拉薩',    nameEn: 'Brazzaville',           lat:  -4.27, lng:  15.28 },
  { name: '金夏沙',    nameEn: 'Kinshasa',              lat:  -4.32, lng:  15.32 },
  { name: '利伯維爾',  nameEn: 'Libreville',            lat:   0.39, lng:   9.45 },
  { name: '聖多美市',  nameEn: 'São Tomé',              lat:   0.34, lng:   6.73 },
  // ── 非洲：東非 ───────────────────────────────────────────────────────────
  { name: '吉布地市',  nameEn: 'Djibouti City',         lat:  11.59, lng:  43.15 },
  { name: '阿迪斯阿貝巴', nameEn: 'Addis Ababa',        lat:   9.03, lng:  38.74 },
  { name: '阿斯馬拉',  nameEn: 'Asmara',                lat:  15.33, lng:  38.93 },
  { name: '摩加迪休',  nameEn: 'Mogadishu',             lat:   2.05, lng:  45.34 },
  { name: '朱巴',      nameEn: 'Juba',                  lat:   4.85, lng:  31.59 },
  { name: '奈洛比',    nameEn: 'Nairobi',               lat:  -1.29, lng:  36.82 },
  { name: '坎帕拉',    nameEn: 'Kampala',               lat:   0.32, lng:  32.58 },
  { name: '基加利',    nameEn: 'Kigali',                lat:  -1.95, lng:  30.06 },
  { name: '基特加',    nameEn: 'Gitega',                lat:  -3.43, lng:  29.93 },
  { name: '多多馬',    nameEn: 'Dodoma',                lat:  -6.17, lng:  35.74 },
  // ── 非洲：南非 ───────────────────────────────────────────────────────────
  { name: '羅安達',    nameEn: 'Luanda',                lat:  -8.84, lng:  13.23 },
  { name: '溫得和克',  nameEn: 'Windhoek',              lat: -22.56, lng:  17.08 },
  { name: '嘉柏隆里',  nameEn: 'Gaborone',              lat: -24.65, lng:  25.91 },
  { name: '比勒陀利亞', nameEn: 'Pretoria',             lat: -25.75, lng:  28.19 },
  { name: '姆巴巴內',  nameEn: 'Mbabane',               lat: -26.32, lng:  31.14 },
  { name: '馬布多',    nameEn: 'Maputo',                lat: -25.97, lng:  32.59 },
  { name: '哈拉雷',    nameEn: 'Harare',                lat: -17.83, lng:  31.05 },
  { name: '盧薩卡',    nameEn: 'Lusaka',                lat: -15.42, lng:  28.28 },
  { name: '里隆威',    nameEn: 'Lilongwe',              lat: -13.97, lng:  33.79 },
  { name: '馬塞盧',    nameEn: 'Maseru',                lat: -29.32, lng:  27.48 },
  // ── 非洲：島國 ───────────────────────────────────────────────────────────
  { name: '塔那那利佛', nameEn: 'Antananarivo',         lat: -18.91, lng:  47.54 },
  { name: '路易港',    nameEn: 'Port Louis',            lat: -20.16, lng:  57.49 },
  { name: '維多利亞',  nameEn: 'Victoria',              lat:  -4.62, lng:  55.45 },
  { name: '莫羅尼',    nameEn: 'Moroni',                lat: -11.70, lng:  43.26 },
  // ── 北美洲 ────────────────────────────────────────────────────────────────
  { name: '華盛頓特區', nameEn: 'Washington DC',        lat:  38.91, lng: -77.04 },
  { name: '紐約',      nameEn: 'New York',              lat:  40.71, lng: -74.01 },
  { name: '洛杉磯',    nameEn: 'Los Angeles',           lat:  34.05, lng:-118.24 },
  { name: '渥太華',    nameEn: 'Ottawa',                lat:  45.42, lng: -75.69 },
  { name: '墨西哥城',  nameEn: 'Mexico City',           lat:  19.43, lng: -99.13 },
  // ── 加勒比海 ─────────────────────────────────────────────────────────────
  { name: '哈瓦那',    nameEn: 'Havana',                lat:  23.13, lng: -82.38 },
  { name: '京斯敦',    nameEn: 'Kingston',              lat:  18.00, lng: -76.79 },
  { name: '拿索',      nameEn: 'Nassau',                lat:  25.05, lng: -77.35 },
  { name: '聖多明哥',  nameEn: 'Santo Domingo',         lat:  18.48, lng: -69.90 },
  { name: '太子港',    nameEn: 'Port-au-Prince',        lat:  18.54, lng: -72.34 },
  { name: '橋鎮',      nameEn: 'Bridgetown',            lat:  13.10, lng: -59.62 },
  { name: '卡斯特里',  nameEn: 'Castries',              lat:  14.02, lng: -61.00 },
  { name: '金斯敦',    nameEn: 'Kingstown',             lat:  13.16, lng: -61.22 },
  { name: '聖喬治市',  nameEn: "St. George's",          lat:  12.05, lng: -61.75 },
  { name: '聖約翰',    nameEn: "St. John's",            lat:  17.12, lng: -61.85 },
  { name: '巴斯特爾',  nameEn: 'Basseterre',            lat:  17.30, lng: -62.72 },
  { name: '羅索',      nameEn: 'Roseau',                lat:  15.30, lng: -61.39 },
  // ── 中美洲 ────────────────────────────────────────────────────────────────
  { name: '貝爾莫潘',  nameEn: 'Belmopan',              lat:  17.25, lng: -88.77 },
  { name: '瓜地馬拉市', nameEn: 'Guatemala City',       lat:  14.64, lng: -90.51 },
  { name: '聖薩爾瓦多', nameEn: 'San Salvador',         lat:  13.69, lng: -89.19 },
  { name: '德古西加巴', nameEn: 'Tegucigalpa',          lat:  14.10, lng: -87.21 },
  { name: '馬拿瓜',    nameEn: 'Managua',               lat:  12.13, lng: -86.29 },
  { name: '聖荷西',    nameEn: 'San José',              lat:   9.93, lng: -84.09 },
  { name: '巴拿馬城',  nameEn: 'Panama City',           lat:   8.99, lng: -79.52 },
  // ── 南美洲 ────────────────────────────────────────────────────────────────
  { name: '聖保羅',    nameEn: 'São Paulo',             lat: -23.55, lng: -46.63 },
  { name: '巴西利亞',  nameEn: 'Brasília',              lat: -15.78, lng: -47.93 },
  { name: '布宜諾斯艾利斯', nameEn: 'Buenos Aires',     lat: -34.61, lng: -58.38 },
  { name: '聖地牙哥',  nameEn: 'Santiago',              lat: -33.45, lng: -70.67 },
  { name: '波哥大',    nameEn: 'Bogotá',                lat:   4.71, lng: -74.07 },
  { name: '利馬',      nameEn: 'Lima',                  lat: -12.05, lng: -77.04 },
  { name: '卡拉卡斯',  nameEn: 'Caracas',               lat:  10.49, lng: -66.88 },
  { name: '基多',      nameEn: 'Quito',                 lat:  -0.23, lng: -78.52 },
  { name: '亞松森',    nameEn: 'Asunción',              lat: -25.29, lng: -57.65 },
  { name: '蒙特維多',  nameEn: 'Montevideo',            lat: -34.90, lng: -56.19 },
  { name: '蘇克雷',    nameEn: 'Sucre',                 lat: -19.04, lng: -65.26 },
  { name: '喬治敦',    nameEn: 'Georgetown',            lat:   6.80, lng: -58.16 },
  { name: '帕拉馬里博', nameEn: 'Paramaribo',           lat:   5.87, lng: -55.17 },
  // ── 大洋洲 ────────────────────────────────────────────────────────────────
  { name: '雪梨',      nameEn: 'Sydney',                lat: -33.87, lng: 151.21 },
  { name: '坎培拉',    nameEn: 'Canberra',              lat: -35.31, lng: 149.12 },
  { name: '威靈頓',    nameEn: 'Wellington',            lat: -41.29, lng: 174.78 },
  { name: '蘇瓦',      nameEn: 'Suva',                  lat: -18.14, lng: 178.44 },
  { name: '霍尼亞拉',  nameEn: 'Honiara',               lat:  -9.43, lng: 160.05 },
  { name: '維拉港',    nameEn: 'Port Vila',             lat: -17.74, lng: 168.32 },
  { name: '努美阿',    nameEn: 'Nouméa',                lat: -22.27, lng: 166.46 },
  { name: '帕利基爾',  nameEn: 'Palikir',               lat:   6.92, lng: 158.18 },
  { name: '馬久羅',    nameEn: 'Majuro',                lat:   7.10, lng: 171.38 },
  { name: '塔拉瓦',    nameEn: 'South Tarawa',          lat:   1.32, lng: 172.98 },
  { name: '努庫阿洛法', nameEn: "Nuku'alofa",           lat: -21.14, lng:-175.20 },
  { name: '阿皮亞',    nameEn: 'Apia',                  lat: -13.83, lng:-171.77 },
  { name: '富納富提',  nameEn: 'Funafuti',              lat:  -8.52, lng: 179.20 },
  { name: '亞連',      nameEn: 'Yaren',                 lat:  -0.55, lng: 166.92 },
  { name: '恩格魯穆德', nameEn: 'Ngerulmud',            lat:   7.50, lng: 134.62 },
  { name: '莫爾斯比港', nameEn: 'Port Moresby',         lat:  -9.44, lng: 147.18 },
];

const cache = new Map<string, { data: CityWeather; at: number }>();
const CACHE_TTL = 5 * 60 * 1000;

async function fetchCityWeather(city: City): Promise<CityWeather> {
  const key = `${city.lat},${city.lng}`;
  const cached = cache.get(key);
  if (cached && Date.now() - cached.at < CACHE_TTL) return cached.data;

  const params = new URLSearchParams({
    latitude:     String(city.lat),
    longitude:    String(city.lng),
    current:      'temperature_2m,apparent_temperature,relative_humidity_2m,wind_speed_10m,weather_code',
    daily:        'temperature_2m_max,temperature_2m_min',
    timezone:     'auto',
    forecast_days: '1',
  });

  const res  = await fetch(`https://api.open-meteo.com/v1/forecast?${params}`);
  const json = await res.json();
  const cur  = json.current;
  const { emoji } = getWmoInfo(cur.weather_code);  // emoji 是語系無關的，快取 OK

  const data: CityWeather = {
    ...city,
    temp:         Math.round(cur.temperature_2m),
    apparentTemp: Math.round(cur.apparent_temperature),
    humidity:     cur.relative_humidity_2m,
    windSpeed:    Math.round(cur.wind_speed_10m),
    weatherCode:  cur.weather_code,
    tempMax:      Math.round(json.daily.temperature_2m_max[0]),
    tempMin:      Math.round(json.daily.temperature_2m_min[0]),
    emoji,
  };

  cache.set(key, { data, at: Date.now() });
  return data;
}

export async function fetchAllCitiesWeather(): Promise<CityWeather[]> {
  const results = await Promise.allSettled(CITIES.map(fetchCityWeather));
  return results
    .filter((r): r is PromiseFulfilledResult<CityWeather> => r.status === 'fulfilled')
    .map(r => r.value);
}

export async function fetchLocationWeather(lat: number, lng: number): Promise<CityWeather> {
  const key = `loc:${lat.toFixed(3)},${lng.toFixed(3)}`;
  const cached = cache.get(key);
  if (cached && Date.now() - cached.at < CACHE_TTL) return cached.data;

  const weatherUrl = `https://api.open-meteo.com/v1/forecast?${new URLSearchParams({
    latitude:      String(lat),
    longitude:     String(lng),
    current:       'temperature_2m,apparent_temperature,relative_humidity_2m,wind_speed_10m,weather_code',
    daily:         'temperature_2m_max,temperature_2m_min',
    timezone:      'auto',
    forecast_days: '1',
  })}`;

  const nominatimUrl =
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=zh-TW,zh,en`;

  const [weatherResult, nominatimResult] = await Promise.allSettled([
    fetch(weatherUrl).then(r => r.json()),
    fetch(nominatimUrl, { headers: { 'User-Agent': 'ap-base-ee/life-center' } }).then(r => r.json()),
  ]);

  if (weatherResult.status !== 'fulfilled') throw new Error('Weather fetch failed');

  const json = weatherResult.value;
  const cur  = json.current;
  const { emoji } = getWmoInfo(cur.weather_code);

  let name = `${lat.toFixed(2)}, ${lng.toFixed(2)}`;
  if (nominatimResult.status === 'fulfilled') {
    const addr = nominatimResult.value?.address ?? {};
    name = addr.city ?? addr.town ?? addr.village ?? addr.county ?? addr.state ?? name;
  }

  const data: CityWeather = {
    name,
    nameEn: name,
    lat,
    lng,
    temp:         Math.round(cur.temperature_2m),
    apparentTemp: Math.round(cur.apparent_temperature),
    humidity:     cur.relative_humidity_2m,
    windSpeed:    Math.round(cur.wind_speed_10m),
    weatherCode:  cur.weather_code,
    tempMax:      Math.round(json.daily.temperature_2m_max[0]),
    tempMin:      Math.round(json.daily.temperature_2m_min[0]),
    emoji,
  };

  cache.set(key, { data, at: Date.now() });
  return data;
}
